import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@folio/stripes-components';
import Pluggable from '../../../Pluggable';
import NavButton from '../../MainNav/NavButton';

function SmartHelpButton({ setIsFullScreen }) {
  return (
    <Pluggable
      type="smart-help"
      renderCustomTrigger={({ onClick }) => (
        <NavButton
          aria-label="Smart Help Assistant"
          data-test-item-smart-help-button
          icon={<Icon icon="comment" />}
          id="smartHelpButton"
          onClick={(e) => {
            e.preventDefault();
            setIsFullScreen(false);
            onClick();
          }}
        />
      )}
    >
      {/* Fallback if plugin not available */}
      <span style={{ display: 'none' }} />
    </Pluggable>
  );
}

SmartHelpButton.propTypes = {
  setIsFullScreen: PropTypes.func,
};

SmartHelpButton.defaultProps = {
  setIsFullScreen: () => {},
};

export default SmartHelpButton;